<agr-page-toolbar
  [pageTitle]="'animal-group-title' | translate"
  [isEmpty]="isAnimalGroupsEmpty$ | async"
  [emptyTitle]="'animal-group.no-animal-groups-title' | translate"
  [emptyDescription]="'animal-group.no-animal-groups-description' | translate"
  emptyImage="assets/images/pigs_001.jpg"
  data-test="animal-group-overview"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'animal-group.add-animal-group' | translate"
  (primaryAction)="addAnimalGroup()"
>
  <mat-nav-list role="list" class="animal-group-overview__list">
    <a
      mat-list-item
      role="listitem"
      class="animal-group-overview__item"
      data-test="animal-group-overview__item"
      *ngFor="let animalGroup of animalGroups$ | async"
      [routerLink]="['/animal-group', animalGroup.id]"
    >
      <mat-icon matListItemAvatar class="list-avatar">table_view</mat-icon>
      <div matListItemTitle>
        {{ animalGroup.name }} ({{ 'productionType.' + animalGroup.productionType | translate }})
      </div>
      <div matListItemLine class="text--gray">
        {{ animalGroup.startDate | date }} - {{ animalGroup.endDate | date }}
      </div>
      <div matListItemMeta>
        <button
          mat-icon-button
          (click)="delete($event, animalGroup)"
          data-test="animal-group-overview__delete"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </a>
  </mat-nav-list>
</agr-page-toolbar>
